import React from "react";
import { styled, Grid as GridBase } from "@mui/material";

export const GridContainer = styled((props) => (
  <GridBase
    {...props}
    container
    justifyContent={props.justifyContent || "flex-start"}
    alignItems={props.alignItems || "center"}
  />
))``;

export const InvoicesListRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;
